/**
 * ber-featured-collection.js
 * Minimal JS for mobile slider pagination dots only.
 * The slider itself runs on native CSS scroll-snap — no library needed.
 */
(function () {
  'use strict';

  function initSection(section) {
    // Guard against double-init (theme editor section:load fires on every save)
    if (section.dataset.berFcInit) return;
    section.dataset.berFcInit = '1';

    var grid = section.querySelector('.ber-fc__grid');
    var dots = section.querySelectorAll('.ber-fc__dot');

    if (!grid || dots.length === 0) return;

    var ticking = false;

    // Update dots based on scroll position
    function updateDots() {
      var cards = grid.querySelectorAll('.ber-fc__card');
      if (cards.length === 0) return;

      // Use IntersectionObserver when available; fall back to scroll math
      var scrollLeft = grid.scrollLeft;
      var cardWidth  = cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(grid).gap || 0);
      var activeIndex = Math.min(
        Math.round(scrollLeft / (cardWidth || 1)),
        dots.length - 1
      );

      dots.forEach(function (dot, i) {
        dot.classList.toggle('ber-fc__dot--active', i === activeIndex);
      });

      ticking = false;
    }

    grid.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateDots);
    }, { passive: true });

    // Dot click → scroll to card
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var cards = grid.querySelectorAll('.ber-fc__card');
        if (cards[i]) {
          // scrollIntoView with inline:'start' respects scroll-padding-left
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.ber-fc').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ber-fc');
    if (section) initSection(section);
  });
})();
